import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, ReplaySubject, map } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { HighlightPipe } from 'ish-core/pipes/highlight.pipe';

@Component({
  selector: 'ish-suggest-search-terms',
  imports: [CommonModule, HighlightPipe, TranslatePipe],
  templateUrl: './suggest-search-terms.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestSearchTermsComponent implements OnInit {
  private shoppingFacade = inject(ShoppingFacade);

  readonly maxRecentlySearchedWords = input<number>(undefined);
  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly submitSearch = output<string>();

  searchTerms$: Observable<string[]>;

  ngOnInit() {
    this.searchTerms$ = this.shoppingFacade.recentSearchTerms$.pipe(
      map(terms => terms.slice(0, this.maxRecentlySearchedWords()))
    );
  }

  submit(term: string) {
    this.submitSearch.emit(term);
  }
}
